import { createContext } from 'react';

const facultyContext = createContext();

export default facultyContext;
